export const licencia = [
  {
    label: "Id",
    name: "idlicencia",
    type: "INTEGER",
    readonly: true,
    showOnList: true,
  },
  {
    label: "Personal",
    name: "idpersonal",
    type: "personal",
    showOnList: true,
  },
  {
    label: "Motivo",
    name: "motivo",
    type: "STRINGINLIST",
    allowNull: false,
    options: ["Licencia", "Estudio", "Médica", "Otro motivo"],
    showOnList: true,
  },
  {
    label: "Fecha",
    name: "fecha",
    type: "DATE",
    showOnList: true,
  },
  {
    label: "Horas",
    name: "horas",
    type: "DECIMAL",
    showOnList: true,
    min: 0,
    max: 12,
  },
  {
    label: "Comentarios",
    name: "comentarios",
    type: "LONGSTRING",
    allowNull: true,
  },
];
